import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PLAN_TIERS, formatPrice } from "../../data/site";
import { Reveal } from "./Reveal";

export default function PricingCards() {
  const navigate = useNavigate();
  return (
    <div className="grid gap-6 md:grid-cols-2 max-w-4xl mx-auto">
      {PLAN_TIERS.map((tier, i) => (
        <Reveal key={tier.key} delay={i * 0.12} className="h-full">
          <div
            data-testid={`pricing-tier-${tier.key}`}
            className={`group relative h-full rounded-3xl border p-6 sm:p-8 card-soft bg-white transition-transform duration-300 hover:-translate-y-1.5 ${
              tier.key === "2" ? "border-brand-blue/30" : "border-black/5"
            }`}
          >
            <div className="text-center">
              <h3 className="font-display text-2xl font-extrabold text-brand-ink">{tier.title}</h3>
              <p className="text-sm text-brand-muted mt-1">{tier.sub}</p>
            </div>

            <div className="mt-6 space-y-4">
              {tier.vehicles.map((v) => (
                <div key={v.vkey} data-testid={`price-${v.vkey}-${tier.key}`} className="rounded-2xl border border-black/5 bg-black/[0.02] p-5 flex items-center justify-between gap-3">
                  <div>
                    <div className="font-display font-bold text-brand-ink">{v.label}</div>
                    <div className="text-xs text-brand-muted mt-0.5">Save {formatPrice(tier.save)}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm text-brand-muted line-through">{formatPrice(v.original)}</div>
                    <div className="font-display font-extrabold text-3xl text-brand-blue leading-none">{formatPrice(v.price)}</div>
                    <div className="text-[11px] text-brand-orange font-semibold mt-1">For First 3 Months</div>
                  </div>
                </div>
              ))}
            </div>

            <button
              data-testid={`book-tier-${tier.key}`}
              onClick={() => navigate(`/book?plan=${tier.key}`)}
              className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-brand-blue text-white font-semibold py-3.5 rounded-2xl hover:scale-[1.02] active:scale-95 transition-transform"
            >
              Book This Plan
              <ArrowUpRight className="w-4 h-4" />
            </button>
          </div>
        </Reveal>
      ))}
    </div>
  );
}
